import get from 'lodash/get';

export default (state: object) => get(state, 'router.location.hash', '');
